import React from 'react';
import {PlayersDashboard as ClassicPlayersDashboard} from './classic';
import {PlayersDashboard as ShowdownPlayersDashboard} from './showdown';

const PlayersDashboard = {
    get(sportConfig) {
        if (sportConfig.isGameTypeShowDown()) {
            return ShowdownPlayersDashboard;
        } else if (sportConfig.isGameTypeClassic()) {
            return ClassicPlayersDashboard;
        }

        throw new Error(`getFilter ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersDashboard};
